import { useEffect, useState } from "react";
import useAxios from "@/hooks/useAxios";
import { config } from "@/config";
import { useSelector } from "react-redux";
import { ReduxState } from "@/redux/type";
import LoadingSkeleton from "@/pages/overview/LoadingSkeleton";

export default function AccountBalance() {
    const [balance, setBalance] = useState<number | null>(null)
    const [loading, setLoading] = useState(true)
    const [showTooltip, setShowTooltip] = useState(false)
    const customerId = useSelector((state: ReduxState) => state.customer.cardCode)
    const axios = useAxios()

    useEffect(() => {
        async function getCustomerBalance() {
            setLoading(true)
            try {
                const res = await axios.get(`${config.backendUrl}/customer-balance`, {
                    params: {
                        cardCode: customerId
                    }
                })
                setBalance(res.data?.[0]?.Balance || 0)
            } catch (error) {
                console.error("Error fetching balance:", error)
            } finally {
                setLoading(false)
            }
        }
        getCustomerBalance()
    }, [customerId])

    if (loading) {
        return <LoadingSkeleton title="Account Balance" lines={1} />;
    }

    return (
        <div className="bg-white shadow rounded-lg p-6">
            <div className="flex items-center gap-2 mb-2">
                <h2 className="text-lg font-semibold">Account Balance</h2>
                <div className="relative">
                    <button
                        className="w-5 h-5 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-sm hover:bg-gray-200 transition-colors"
                        onClick={() => setShowTooltip(!showTooltip)}
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        aria-label="Account balance information"
                    >
                        ?
                    </button>
                    {showTooltip && (
                        <div className="absolute z-10 left-1/2 -translate-x-1/2 mt-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg shadow-lg w-48">
                            <p>This is your current outstanding balance - the total amount of your open invoices 
                                that are not yet paid to Lionsfloor.</p>
                            <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-800 rotate-45"></div>
                        </div>
                    )}
                </div>
            </div>
            <div className="text-2xl">
                {balance === null ? (
                    <span className="text-gray-500">Unable to load balance</span>
                ) : (
                    `$${Math.round(balance * 100) / 100}`
                )}
            </div>
        </div>
    );
} 